import { render, staticRenderFns } from "./AlternativeHotel.vue?vue&type=template&id=3a5c31c4&"
import script from "./AlternativeHotel.vue?vue&type=script&lang=js&"
export * from "./AlternativeHotel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports